import { render, staticRenderFns } from "./WLoading.vue?vue&type=template&id=548dfea4&scoped=true&"
import script from "./WLoading.vue?vue&type=script&lang=js&"
export * from "./WLoading.vue?vue&type=script&lang=js&"
import style0 from "./WLoading.vue?vue&type=style&index=0&id=548dfea4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548dfea4",
  null
  
)

export default component.exports